import { render, staticRenderFns } from "./agregarAdministrador.vue?vue&type=template&id=5108a380&"
import script from "./agregarAdministrador.vue?vue&type=script&lang=js&"
export * from "./agregarAdministrador.vue?vue&type=script&lang=js&"
import style0 from "./agregarAdministrador.vue?vue&type=style&index=0&id=5108a380&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports